/* ============================================================
   AMARIONT — CAPILLAR THEME
   theme.js · Vanilla JS only · No jQuery
   ============================================================ */

(function () {
  'use strict';

  /* ---- Mobile Menu ---- */
  function initMobileMenu() {
    const hamburger = document.querySelector('.hamburger');
    const drawer    = document.querySelector('.mobile-drawer');
    const overlay   = document.querySelector('.mobile-overlay');
    const closeBtn  = document.querySelector('.mobile-drawer__close');

    if (!hamburger || !drawer) return;

    function openMenu() {
      hamburger.classList.add('active');
      drawer.classList.add('open');
      if (overlay) overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
      hamburger.setAttribute('aria-expanded', 'true');
    }

    function closeMenu() {
      hamburger.classList.remove('active');
      drawer.classList.remove('open');
      if (overlay) overlay.classList.remove('active');
      document.body.style.overflow = '';
      hamburger.setAttribute('aria-expanded', 'false');
    }

    hamburger.addEventListener('click', function () {
      hamburger.classList.contains('active') ? closeMenu() : openMenu();
    });

    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    if (overlay)  overlay.addEventListener('click', closeMenu);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });
  }

  /* ---- Header scroll shadow ---- */
  function initHeaderScroll() {
    const header = document.querySelector('.site-header');
    if (!header) return;

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          header.classList.toggle('scrolled', window.scrollY > 10);
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ---- Intersection Observer for scroll animations ---- */
  function initScrollAnimations() {
    if (!('IntersectionObserver' in window)) return;

    var els = document.querySelectorAll('.anim-fade-up');
    if (!els.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function (el) { observer.observe(el); });
  }

  /* ---- AJAX Cart ---- */
  function initAjaxCart() {
    document.addEventListener('click', function (e) {
      var addBtn = e.target.closest('[data-add-to-cart]');
      if (!addBtn) return;
      e.preventDefault();

      var variantId = addBtn.dataset.variantId;
      if (!variantId) return;

      var originalText = addBtn.textContent;
      addBtn.textContent = 'Añadiendo…';
      addBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      })
      .then(function () {
        addBtn.textContent = '¡Añadido! ✓';
        refreshCartCount();
        setTimeout(function () {
          addBtn.textContent = originalText;
          addBtn.disabled = false;
        }, 2200);
      })
      .catch(function (err) {
        var msg = (err && err.description) ? err.description : 'Error — reintenta';
        addBtn.textContent = msg;
        addBtn.disabled = false;
        setTimeout(function () {
          addBtn.textContent = originalText;
        }, 2800);
      });
    });
  }

  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
        });
      })
      .catch(function () {});
  }

  /* ---- Marquee duplicate for seamless loop ---- */
  function initMarquees() {
    document.querySelectorAll('.marquee-strip__inner, .announcement-bar__inner').forEach(function (inner) {
      var clone = inner.cloneNode(true);
      inner.parentElement.appendChild(clone);
    });
  }

  /* ---- Init on DOM ready ---- */
  document.addEventListener('DOMContentLoaded', function () {
    initMobileMenu();
    initHeaderScroll();
    initScrollAnimations();
    initAjaxCart();
    initMarquees();
    refreshCartCount();
  });

})();
